const splitCompatibilityHeaderValue = (value: string): string[] => {
	return value
		.split(',')
		.map((compatibility) => compatibility.trim().toLowerCase())
		.filter((compatibility) => compatibility !== '');
};

const rolloutCompatibleLegacyResponseTokensByAppCompatibility: Record<string, readonly string[]> = {
	// ZF/classic release branch tokens observed in old customer backend revisions and
	// kept during the staggered app rollout. These are global app-vs-backend
	// compatibility exceptions, not proof that every develop feature works against
	// every release backend.
	meganeura: ['ceratioidei', 'melanocetus_johnsonii'],
};

const responseContainsCompatibleToken = (
	expectedCompatibility: string,
	responseCompatibilityTokens: string[]
): boolean => {
	if (responseCompatibilityTokens.includes(expectedCompatibility)) {
		return true;
	}

	const rolloutCompatibleTokens =
		rolloutCompatibleLegacyResponseTokensByAppCompatibility[expectedCompatibility] ?? [];

	return rolloutCompatibleTokens.some((token) => responseCompatibilityTokens.includes(token));
};

export const responseContainsRolloutCompatibleLegacyToken = (
	currentAppCompatibility: string | undefined,
	headerValue: unknown
): boolean => {
	const expectedCompatibility = currentAppCompatibility?.trim().toLowerCase() ?? '';
	const responseCompatibilityTokens = appCompatibilityTokensFromHeader(headerValue);

	if (expectedCompatibility === '' || responseCompatibilityTokens.includes(expectedCompatibility)) {
		return false;
	}

	const rolloutCompatibleTokens =
		rolloutCompatibleLegacyResponseTokensByAppCompatibility[expectedCompatibility] ?? [];

	return rolloutCompatibleTokens.some((token) => responseCompatibilityTokens.includes(token));
};

export const appCompatibilityTokensFromHeader = (headerValue: unknown): string[] => {
	if (Array.isArray(headerValue)) {
		return headerValue.flatMap((value) => appCompatibilityTokensFromHeader(value));
	}

	if (typeof headerValue !== 'string') {
		return [];
	}

	return splitCompatibilityHeaderValue(headerValue);
};

export const appCompatibilityMismatchFromHeader = (
	currentAppCompatibility: string | undefined,
	headerValue: unknown
): boolean | null => {
	const expectedCompatibility = currentAppCompatibility?.trim().toLowerCase() ?? '';
	const responseCompatibilityTokens = appCompatibilityTokensFromHeader(headerValue);

	if (expectedCompatibility === '' || responseCompatibilityTokens.length === 0) {
		return null;
	}

	return !responseContainsCompatibleToken(expectedCompatibility, responseCompatibilityTokens);
};
